import { createAction, props } from '@ngrx/store';
import { Signin } from './signin.interface';

export const loadApps = createAction(
  '[App] Start Apps'
);

export const getUserInfoSuccess = createAction(
  '[Backend API] Successfully fetched User Info',
  props<({data: Signin})>()
);




